<template>
    <div>
        <div class="common-table">
            <el-table v-loading="loading" :data="recordList.beanList" :row-key="(row)=>row.randomId+row.time" height="100%">
                <el-table-column label="昵称" min-width="150" align="center" prop="nickName"/>
                <el-table-column label="用户ID" min-width="120" align="center" prop="randomId"/>
                <el-table-column label="牌局类型" align="center">
                    <template slot-scope="scope">{{scope.row.roomType | roomTypeName}}</template>
                </el-table-column>
                <el-table-column label="彩池分池" align="center">
                    <template slot-scope="scope">{{scope.row.jackpotType | jackpotTypeName}}</template>
                </el-table-column>
                <el-table-column label="牌局" align="center" prop="roomName"/>
                <el-table-column label="盲注" align="center" prop="blindName"/>
                <el-table-column label="牌型" align="center">
                    <template slot-scope="scope">{{scope.row.pocerType | pocerTypeName}}</template>
                </el-table-column>
                <el-table-column label="数额" align="center" prop="amout">
                  <template slot-scope="scope">{{scope.row.amout | jackpotNumber}}</template>
                </el-table-column>
                <el-table-column label="时间" min-width="150" align="center" prop="time"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="recordList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>

</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                currentPage:1
            }
        },
        computed: {
            ...mapState('jackpot', ['recordList'])
        },
        methods: {
            ...mapActions('jackpot', ['getRecord']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getRecord(page).then(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>